export default __webpack_public_path__ + "static/media/RTP_FlipCard.be6c4bd2.webp";